import { styled } from '@mui/material/styles';
import { ToastContainer as ToastifyToastContainer } from 'react-toastify';

export const ToastContainer = styled(ToastifyToastContainer)`
  &&&.Toastify__toast-container {
    width: 100%;
    max-width: 450px;
  }
  .Toastify__toast {
    border-radius: 8px;
    box-shadow: 0 4px 12px #0000001a;
    color: ${(props) => props.theme.palette.text.primary};
    font-family: ${(props) => props.theme.typography.fontFamily};
    background-color: #ffffffff;
    padding: 10px 24px;
  }
  .Toastify__toast-body {
    font-family: ${(props) => props.theme.typography.fontFamily};
    padding: 0;
  }
  .Toastify__toast--default {
    color: ${(props) => props.theme.palette.text.primary};

    svg {
      fill: ${(props) => props.theme.palette.text.primary};
    }
  }
  .Toastify__toast--success {
  }
  .Toastify__toast--info {
  }
  .Toastify__toast--warning {
  }
  .Toastify__toast--error {
  }

  .Toastify__progress-bar {
    background: ${(props) => props.theme.palette.text.primary};
  }
  .Toastify__progress-bar--bg {
    opacity: 1;
    background: #ecf1fc;
  }
  .Toastify__progress-bar--rtl {
  }
  .Toastify__progress-bar-theme--light {
  }
  .Toastify__progress-bar-theme--dark {
  }
  .Toastify__progress-bar--info {
  }
  .Toastify__progress-bar--success {
  }
  .Toastify__progress-bar--warning {
  }
  .Toastify__progress-bar--error {
  }
  .Toastify__close-button {
    align-self: center;
    color: ${(props) => props.theme.palette.text.primary};
    opacity: 1;
  }
  .Toastify__toast-icon {
    width: 18px;
    height: 18px;
    color: ${(props) => props.theme.palette.text.primary};
    svg {
      fill: ${(props) => props.theme.palette.text.primary};
    }
  }
  .Toastify__spinner {
    width: 18px;
    height: 18px;
    border-right-color: ${(props) => props.theme.palette.primary.main};
  }
`;
